import styled from 'styled-components';

const Nav = styled.nav`
  display: flex;
  place-content: center;
  flex: 1;
  height: inherit;
  max-width: 1000px;
`;

const NavList = styled.ul`
  display: flex;
  height: inherit;
  padding: 0px 16px;
`;

const DesktopNavigationStyles = {
  Nav,
  NavList,
};

export default DesktopNavigationStyles;
